export default () => {
  const body = window.document.body;

  const initial = {
    scrollY: window.pageYOffset,
    scrollX: window.pageXOffset,
    position: body.style.position,
    top: body.style.top,
    width: body.style.width
  };

  body.style.position = 'fixed';
  body.style.top = `-${initial.scrollY}px`;
  body.style.width = '100%';

  const reenable = () => {
    body.style.position = initial.position;
    body.style.top = initial.top;
    body.style.width = initial.width;

    window.scrollTo(initial.scrollX, initial.scrollY);
  };

  return reenable;
};
